import _ from 'lodash'
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useGetUsers } from '../hooks/api/users'
import { tableCellClasses } from '@mui/material/TableCell'
import { styled } from '@mui/material/styles'
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  Paper,
  Container,
  Button,
  IconButton,
  Pagination,
  Box,
  Grid,
  Typography,
  TextField,
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import CheckIcon from '@mui/icons-material/Check'
import ClearIcon from '@mui/icons-material/Clear'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.common.black,
    // color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}))

const Admin = () => {
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')

  const { data, refetch } = useGetUsers({ page, limit: 10, search: _.trim(search) })

  let searchTimer

  useEffect(() => {
    const trimmed = _.trim(search)

    if (trimmed) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      searchTimer = setTimeout(() => {
        setPage(1)
        refetch()
      }, 1500)
    }

    return () => {
      clearTimeout(searchTimer)
    }
  }, [search])

  const handlePageChange = (event, value) => {
    setPage(value)
  }

  return (
    <Container>
      <Box sx={{ flexGrow: 1 }} paddingY='0.5rem'>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant='h5'>Admin Panel</Typography>
          </Grid>
          <Grid item xs={8}>
            <TextField
              label='Search'
              size='small'
              value={search}
              onChange={(v) => setSearch(v.target.value)}
            />
          </Grid>
          <Grid item xs={4} textAlign='right'>
            <Button component={Link} to='/admin/users/create' variant='contained' color='primary'>
              new user
            </Button>
          </Grid>
        </Grid>
      </Box>

      <TableContainer component={Paper}>
        <Table size='small' sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <StyledTableCell>Email</StyledTableCell>
              <StyledTableCell align='right'>Role</StyledTableCell>
              <StyledTableCell align='right'>Admin</StyledTableCell>
              <StyledTableCell align='right'>Active</StyledTableCell>
              <StyledTableCell align='right'></StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {_.map(data?.docs, ({ _id, email, isAdmin, role, isActive }) => (
              <StyledTableRow key={_id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <StyledTableCell component='th' scope='row'>
                  {email}
                </StyledTableCell>
                <StyledTableCell align='right'>{role}</StyledTableCell>
                <StyledTableCell align='right'>
                  {isAdmin ? <CheckIcon color='success' /> : <ClearIcon color='error' />}
                </StyledTableCell>
                <StyledTableCell align='right'>
                  {isActive ? <CheckIcon color='success' /> : <ClearIcon color='error' />}
                </StyledTableCell>
                <StyledTableCell align='right'>
                  <IconButton size='small' component={Link} to={`/admin/users/edit/${_id}`}>
                    <EditIcon />
                  </IconButton>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ flexGrow: 1 }} paddingY='0.5rem'>
        <Pagination
          count={_.chain(data?.totalDocs).divide(10).ceil().value()}
          page={page}
          onChange={handlePageChange}
          variant='outlined'
          shape='rounded'
          size='small'
        />
      </Box>
    </Container>
  )
}

export default Admin
